import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

type UserIdentityBadgeProps = {
  name: string | null | undefined;
  subtitle?: string | null | undefined;
  photoUrl?: string | null | undefined;
  className?: string;
};

function getInitials(name: string | null | undefined) {
  const normalized = String(name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');

  return normalized || 'U';
}

export function UserIdentityBadge({ name, subtitle, photoUrl, className }: UserIdentityBadgeProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <Avatar className="h-11 w-11 rounded-2xl">
        {photoUrl ? <img src={photoUrl} alt={name ?? 'Usuário'} className="h-full w-full object-cover" /> : null}
        {!photoUrl ? (
          <AvatarFallback className="gradient-primary rounded-2xl text-sm font-semibold text-white">
            {getInitials(name)}
          </AvatarFallback>
        ) : null}
      </Avatar>
      <div className="min-w-0 text-left">
        <p className="truncate text-sm font-semibold">{name}</p>
        {subtitle ? <p className="text-sidebar-foreground/75 truncate text-xs">{subtitle}</p> : null}
      </div>
    </div>
  );
}
